export function shouldResetShellStack(rootState: { routes: Array<{ name: string }> }): boolean {
  return rootState.routes.some((route) => route.name === 'AppShell');
}
